/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Icon, formatDateTime } from 'sarsaparilla';
import { isValid } from 'date-fns';
import * as tripPlannerActions from '../actions/tripPlanner';

const propTypes = {
    dispatch: PropTypes.func,
    tripPlanner: PropTypes.object,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    onApplyFilters: PropTypes.func,
    displayAvailability: PropTypes.object,
};

const defaultProps = {
    displayAvailability: { isValid: false, dates: [] },
};

class TripItineraryDatesFiltersContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { displayCalendar: false };
        this.onToggleFilters = this.onToggleFilters.bind(this);
    }

    onToggleFilters() {
        this.props.dispatch(
            tripPlannerActions.setFiltersVisible(!this.props.tripPlanner.filtersVisible)
        );
    }

    handleResetFilters() {
        this.props.dispatch(tripPlannerActions.resetSearchFilters());
    }

    formatDate = (date) => {
        const setFormatDate = formatDateTime();
        try {
            const parsedDate = typeof date === 'string' ? new Date(date) : date;

            if (!isValid(parsedDate)) {
                return '';
            }
            return setFormatDate(parsedDate, {
                timeZone: 'UTC',
                format: 'L',
            });
        } catch {
            return '';
        }
    };

    render() {
        let filterCount = 0;
        if (this.props.tripPlanner && this.props.tripPlanner.fg) {
            filterCount = this.props.tripPlanner.fg.length;
        }

        if (this.props.tripPlanner && this.props.tripPlanner.uiFilters) {
            filterCount += Object.keys(this.props.tripPlanner.uiFilters.agencies).length;
            filterCount += Object.keys(this.props.tripPlanner.uiFilters.occupants).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.reservable
            ).length;

            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.activities
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.accommodations
            ).length;

            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.campsiteUseTypes
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.campsiteTypes
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.campsiteAmenities
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.campsiteEquipment
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.campsiteElectricityHookup
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.campsiteVehicleLength
            ).length;

            filterCount += Object.keys(this.props.tripPlanner.uiFilters.tourTypes).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.tourAccessible
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.tourDifficulty
            ).length;
            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.tourDuration
            ).length;
            filterCount += Object.keys(this.props.tripPlanner.uiFilters.tourPrice).length;
            filterCount += Object.keys(this.props.tripPlanner.uiFilters.tourTime).length;

            filterCount += Object.keys(
                this.props.tripPlanner.uiFilters.permitTypes
            ).length;
        }

        let startDateStr = null;
        if (this.props.startDate) {
            startDateStr = this.formatDate(this.props.startDate);
        }

        let endDateStr = null;
        if (this.props.endDate) {
            endDateStr = this.formatDate(this.props.endDate);
        }

        return (
            <div className="trip-planner-dates-filters">
                <div className="trip-dates-readonly" data-testid="trip-dates-readonly">
                    <Icon iconName="calendar-note" />
                    <div className="date">{startDateStr}</div>
                    <Icon iconName="arrow-forward" />
                    <div className="date">{endDateStr}</div>
                </div>

                <div className="rec-filter-clear-wrap">
                    <div className="rec-select-holder trip-planner-filters-dropdown">
                        <button
                            type="button"
                            className={`rec-select ${
                                this.props.tripPlanner.filtersVisible ? 'open' : ''
                            }`}
                            title="open filters"
                            aria-label="open filters"
                            aria-expanded={this.props.tripPlanner.filtersVisible}
                            onClick={this.onToggleFilters}
                        >
                            <span className="rec-select-label">
                                {filterCount > 0 && (
                                    <span>
                                        {filterCount}{' '}
                                        <strong>
                                            {filterCount === 1 && 'Filter'}{' '}
                                            {filterCount > 1 && 'Filters'}{' '}
                                        </strong>
                                    </span>
                                )}
                                {filterCount === 0 && <span>Filters</span>}
                            </span>
                            <span className="rec-select-icon">
                                {!this.props.tripPlanner.filtersVisible && (
                                    <Icon
                                        iconName="arrow-down"
                                        aria-label="Open filters"
                                    />
                                )}
                                {this.props.tripPlanner.filtersVisible && (
                                    <Icon
                                        iconName="arrow-up"
                                        aria-label="Close filters"
                                    />
                                )}
                            </span>
                        </button>
                    </div>

                    {filterCount > 0 && (
                        <button
                            type="button"
                            className="rec-button-link"
                            disabled={filterCount === 0 ? 'disabled' : ''}
                            onClick={(e) => this.handleResetFilters(e)}
                        >
                            <span>Clear Filters</span>
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

TripItineraryDatesFiltersContainer.propTypes = propTypes;
TripItineraryDatesFiltersContainer.defaultProps = defaultProps;

function select(state) {
    return {
        tripPlanner: state.tripPlanner,
    };
}

export default connect(select)(TripItineraryDatesFiltersContainer);
